import React, { useContext, createContext, useMemo } from 'react';
import { ConfigContext, SizeContext } from '../ConfigProvider';
var Context = /*#__PURE__*/createContext({});

var InputGroup = function InputGroup(props) {
  var className = props.className,
      children = props.children,
      prefixCls = props.prefixCls,
      _props$compact = props.compact,
      compact = _props$compact === void 0 ? true : _props$compact,
      customSize = props.size,
      disabled = props.disabled,
      round = props.round;

  var _useContext = useContext(ConfigContext),
      getPrettyCls = _useContext.getPrettyCls;

  var contextSize = useContext(SizeContext);
  var bem = getPrettyCls('input-group', prefixCls);
  var value = {
    size: customSize || contextSize,
    disabled: disabled,
    round: round
  };
  var classes = [bem({
    compact: compact
  }), className].join(' ');
  var wrapperChildren = useMemo(function () {
    if (Array.isArray(children)) {
      return children;
    }

    return [children];
  }, [children]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement("div", {
    className: classes
  }, wrapperChildren.map(function (item) {
    return /*#__PURE__*/React.cloneElement(item, value);
  })));
};

export default InputGroup;